import { loyaltyEarningRuleSchema } from "@redotech/redo-loyalty-common/loyalty-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const completeEarningEventForLoyaltyCustomer = {
  name: "completeEarningEventForLoyaltyCustomer" as const,
  input: z.object({
    customerId: zExt.objectId(),
    completedEarningRule: loyaltyEarningRuleSchema,
  }),
  output: z.object({ success: z.boolean() }),
};
